import {
  COMPANIES_HOUSE_UK_SEARCH_COMPANIES,
  COMPANIES_HOUSE_UK_GET_FILING_HISTORY,
  COMPANIES_HOUSE_UK_GET_OFFICERS,
} from "./actionType";

import {
  companiesHouseGovUKSearchCompaniesSuccess,
  companiesHouseGovUKSearchCompaniesFailure,
  companiesHouseGovUKGetFilingHistorySuccess,
  companiesHouseGovUKGetFilingHistoryFailure,
  companiesHouseGovUKGetOfficersSuccess,
  companiesHouseGovUKGetOfficersFailure,
} from "./action";

import {
  companiesHouseGovUKSearchCompaniesApi,
  companiesHouseGovUKGetFilingHistoryApi,
  companiesHouseGovUKGetOfficersApi,
} from "../../helpers/fakebackend_helper";

import { put, takeLatest, call, all } from "redux-saga/effects";

//COMPANIES_HOUSE_UK_SEARCH_COMPANIES
export function* companiesHouseGovUKSearchCompaniesSaga(action) {
  try {
    const response = yield call(
      companiesHouseGovUKSearchCompaniesApi,
      action.payload
    );
    yield put(companiesHouseGovUKSearchCompaniesSuccess(response));
  } catch (error) {
    yield put(companiesHouseGovUKSearchCompaniesFailure(error));
  }
}

export function* companiesHouseGovUKSearchCompaniesWatcher() {
  yield takeLatest(
    COMPANIES_HOUSE_UK_SEARCH_COMPANIES,
    companiesHouseGovUKSearchCompaniesSaga
  );
}

//COMPANIES_HOUSE_UK_GET_FILING_HISTORY
export function* companiesHouseGovUKGetFilingHistorySaga(action) {
  try {
    const response = yield call(
      companiesHouseGovUKGetFilingHistoryApi,
      action.payload
    );
    yield put(companiesHouseGovUKGetFilingHistorySuccess(response));
  } catch (error) {
    yield put(companiesHouseGovUKGetFilingHistoryFailure(error));
  }
}

export function* companiesHouseGovUKGetFilingHistoryWatcher() {
  yield takeLatest(
    COMPANIES_HOUSE_UK_GET_FILING_HISTORY,
    companiesHouseGovUKGetFilingHistorySaga
  );
}

//COMPANIES_HOUSE_UK_GET_OFFICERS
export function* companiesHouseGovUKGetOfficersSaga(action) {
  try {
    const response = yield call(
      companiesHouseGovUKGetOfficersApi,
      action.payload
    );
    yield put(companiesHouseGovUKGetOfficersSuccess(response));
  } catch (error) {
    yield put(companiesHouseGovUKGetOfficersFailure(error));
  }
}

export function* companiesHouseGovUKGetOfficersWatcher() {
  yield takeLatest(
    COMPANIES_HOUSE_UK_GET_OFFICERS,
    companiesHouseGovUKGetOfficersSaga
  );
}

export default function* CompaniesHouseGovUK() {
  yield all([
    call(companiesHouseGovUKSearchCompaniesWatcher),
    call(companiesHouseGovUKGetFilingHistoryWatcher),
    call(companiesHouseGovUKGetOfficersWatcher),
  ]);
}
